// extracted by mini-css-extract-plugin
export default {"info":"views-ProductPage-configurators-notforsale-styles__info--XU9F4"};